import React from 'react'
import useDispatch from 'hooks/use-dispatch'
import useSelector from 'hooks/use-selector'
import isNavigatingProductSelect from 'modules/product/redux/selectors/is-navigating-to-product'
import updateIsNavigatingProductAction from 'modules/product/redux/actions/is-navigating-to-product'

const DELAY_BEFORE_UPDATING_IS_NAVIGATING_IN_MS = 0

export default function ProductPageHandleIsNavigating () {
  const dispatch = useDispatch()
  const isNavigating = useSelector(isNavigatingProductSelect)
  const timerIdRef = React.useRef()

  React.useEffect(() => {
    if (!isNavigating) {
      return
    }

    if (timerIdRef.current) {
      clearTimeout(timerIdRef.current)
      timerIdRef.current = null
    }

    timerIdRef.current = setTimeout(() => {
      timerIdRef.current = null
      dispatch(updateIsNavigatingProductAction(false))
    }, DELAY_BEFORE_UPDATING_IS_NAVIGATING_IN_MS)
  }, [isNavigating])

  const handleUnMount = () => {
    clearTimeout(timerIdRef.current)
  }

  React.useEffect(() => {
    return handleUnMount
  }, [])

  return (
    <></>
  )
}
